/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DeliveryBoxIsoClosedIcon16Solid = forwardRef('DeliveryBoxIsoClosedIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.802.89a2.5 2.5 0 0 1 2.396 0l4.5 2.458c.232.127.439.287.615.473l-2.621 1.442-6.307-3.599L6.802.891Z" }),
        React.createElement("path", { d: "M4.354 2.227 2.302 3.348a2.498 2.498 0 0 0-.615.473L8 7.293l2.664-1.465-6.31-3.6Z" }),
        React.createElement("path", { d: "m8.625 8.376 6.295-3.462c.052.203.08.414.08.628v4.915a2.5 2.5 0 0 1-1.302 2.195l-4.5 2.457c-.183.1-.376.176-.573.227v-6.96Z" }),
        React.createElement("path", { d: "M7.375 8.376v6.96a2.5 2.5 0 0 1-.573-.227l-4.5-2.457A2.5 2.5 0 0 1 1 10.458V5.541c0-.214.028-.425.08-.628l6.295 3.462Z" })));
});
